import { NgModule } from "@angular/core";
import { HelpTextComponent } from "./help-text.component";
import { CommonModule } from "@angular/common";

@NgModule({
	declarations: [HelpTextComponent],
	imports: [CommonModule],
	exports: [HelpTextComponent]
})
export class HelpTextModule {}
